exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sideBar[data-v-33ec43fc]{margin-top:60px;overflow-y:scroll;z-index:1100}[data-v-33ec43fc]::-webkit-scrollbar{width:0 !important}[data-v-33ec43fc]::-webkit-scrollbar{width:0 !important;height:0}", ""]);

// exports
